<template>
	<div>
		<ul class="pt-4 font-bold text-cyan underline text-left">
			<li class="py-2" v-for="{url, urlText, id} in this.data" :key="id">
				<a :href="url" target="_blank" rel="noopener">
					<font-awesome-icon :icon="['fas', `${iconName}`]" class="fa-lg" />
					<span class="pl-4">{{urlText}}</span>
				</a>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	name: 'link-list',
	props: {
		data: {
			type: Array
		},
		iconName: {
			type: String
		}
	}
}
</script>
<style lang="postcss" scoped>
</style>